import { render, staticRenderFns } from "./RemoveRoomOrSpacePopup.vue?vue&type=template&id=bb4cbaa0&scoped=true"
import script from "./RemoveRoomOrSpacePopup.vue?vue&type=script&lang=ts"
export * from "./RemoveRoomOrSpacePopup.vue?vue&type=script&lang=ts"
import style0 from "./RemoveRoomOrSpacePopup.vue?vue&type=style&index=0&id=bb4cbaa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4cbaa0",
  null
  
)

export default component.exports